import React, { useMemo } from 'react';
import styled from 'styled-components';
import { MessagePlugin } from 'tdesign-react';
import { isVoid } from '@/utils/common';
import { convertDetailToProps } from '@/pages/Maintenance/Template/Variables/components/VarInput';
import Tip from '@/components/Tip';
import IpVariables from './IpVariables';
import CmpVariables from './CmpVariables';

/**
 * @typedef {Object} Props
 * @prop {Array} hosts 需要有(必须)id、serviceIp、hostIp
 * @prop {Array} cmpVariables 需要有 (必须)id、(必须)key、（必须）varId、(必须)tagSelect默认列表中显示（或调整）、(必须)canDelete 是否允许删除 、(必须)originValue预备删除后恢复的数据、其他变量通用信息
 * @prop {function} setCmpVariables 全量集群变量修改，无需额外处理，保留所有其他属性
 * @prop {Array} ipVariables 同cmpVariables， 需包含 (必须)hostId 对应hosts中的 id
 * @prop {function} setIpVariables 同setCmpVariables
 * @prop {Number} scopeType // 变量域 0 主机变量 1容器变量
 * @prop {String=} descTitle // 备注 title自定义
 */

/**
 * 变量组件，使用有约束，具体看参数介绍
 * @param {Props} props
 */
export default function Variables({
  cmpVariables,
  setCmpVariables,
  ipVariables,
  setIpVariables,
  hosts,
  scopeType,
  descTitle = '备注',
  ...others
}) {
  // 所有变量
  const variables = useMemo(() => [...cmpVariables, ...ipVariables], [cmpVariables, ipVariables]);

  // const getFilterdDeptVarialbes = useMemoizedFn(
  //   (vars) =>
  //     vars.filter((item) => {
  //       const { dependId } = item;
  //       if (!isVoid(dependId)) {
  //         const depended = getDependVariable(variables, dependId);
  //         if (item.dependValue !== depended.defaultValue) {
  //           return false;
  //         }
  //       }
  //       return true;
  //     }),
  //   [variables],
  // );

  // // 如果有依赖，检查依赖的值是否符合条件，不符合则剔除
  // const filteredCmpVariables = useMemo(
  //   () => getFilterdDeptVarialbes(cmpVariables),
  //   [cmpVariables, getFilterdDeptVarialbes],
  // );
  // const filteredIpVariables = useMemo(
  //   () => getFilterdDeptVarialbes(ipVariables),
  //   [ipVariables, getFilterdDeptVarialbes],
  // );

  // console.log(cmpVariables);

  return (
    <Root {...others}>
      <CmpVariables
        variables={variables}
        cmpVariables={cmpVariables}
        setCmpVariables={setCmpVariables}
        ipVariables={ipVariables}
        descTitle={descTitle}
        setIpVariables={setIpVariables}
      />
      {scopeType === 0 && (
        <IpVariables
          variables={variables}
          scopeType={scopeType}
          hosts={hosts}
          descTitle={descTitle}
          ipVariables={ipVariables}
          setIpVariables={setIpVariables}
        />
      )}
    </Root>
  );
}

// 获取依赖变量
export const getDependVariable = (variables, dependId) => {
  return variables.find((item) => item.varId === dependId);
};

// key渲染(包含提示信息)
export const getKeyNode = (variables, row) => {
  let dependTip, minTip, maxTip;
  if (!isVoid(row.dependId)) {
    const depend = getDependVariable(variables, row.dependId);

    dependTip = (
      <div>
        依赖：{depend?.key}={row.dependValue}
      </div>
    );
  }
  if (row.showType === 3) {
    const { min, max } = convertDetailToProps(row.showDetail) || {};
    if (!isVoid(min)) minTip = <div>最小值：{min}</div>;
    if (!isVoid(max)) maxTip = <div>最大值：{max}</div>;
  }
  const hasTip = dependTip || minTip || maxTip;
  return hasTip ? (
    <Tip
      content={
        <>
          {dependTip}
          {minTip}
          {maxTip}
        </>
      }
    >
      {row.key}
    </Tip>
  ) : (
    row.key
  );
};

// 校验，通过返回true
export const validateAll = (cmpVariables, ipVariables) => {
  let error = '';
  const variables = [...cmpVariables, ...ipVariables];
  variables.forEach((item) => {
    if (isVoid(item.defaultValue)) {
      error = '请先填写所有变量';
    }
  });

  if (error) {
    MessagePlugin.warning(error);
    return false;
  }
  return true;
};

const Root = styled.div`
  flex: 1;
  padding: 16px 20px;
`;
